<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/expense' }">报销管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}报销</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 申请信息 -->
    <div class="base1">
      <h3 class="ntitle">申请信息</h3>
      <ul>
        <li>
          <p>
            <label>姓名：</label><a>{{ userArr.realname }} {{ userArr.en_name }} </a>
          </p>
          <p>
            <label>职位：</label><a>{{ userArr.role?.role_name }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>部门：</label><a>{{ userArr.department?.en_name }}</a>
          </p>
          <p>
            <label>直属领导：</label><a>{{ userArr.leader_name }} {{ userArr.leader_en_name }}</a>
          </p>
        </li>
      </ul>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">项目信息</div>
        <el-form-item label="报销说明：" prop="description">
          <el-col :span="12">
            {{ form.description }}
          </el-col>
        </el-form-item>

        <el-form-item label="报销日期：" prop="expense_date_str">
          <el-col :span="12">
            {{ form.expense_date_str }}
          </el-col>
        </el-form-item>

        <el-form-item label="报销金额：" prop="project_time">
          <el-col :span="12">
            {{ form.total_expense_amount }}
          </el-col>
        </el-form-item>

      </el-form>
    </div>

    <div class="table" style="margin-bottom: 20px;">
      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row ref="table">
        <el-table-column type="index" label="序号" header-align="center" align="center" min-width="80" />
        <el-table-column prop="service_type" label="服务类目" header-align="center" align="center" min-width="200">
          <template slot-scope="scope">
            <el-select ref="serviceType" v-model="scope.row.service_type" placeholder="请选择服务类目"
              style="margin-right: 0; width: 100%;" filterable @change="v => changeData(v, scope)"
              v-if="scope.row.editFlag">
              <el-option :label="v.category_name" :value="v.id" v-for="(v, i) in serviceList" :key="i"></el-option>
            </el-select>
            <div class="inner" v-else @click="handleCurrentChange(scope, 'serviceType')">{{ scope.row.category_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="expense_amount" label="金额（元）" header-align="center" min-width="150" align="center">
          <template slot-scope="scope">
            <el-input ref="expenseAmount" @input="_limitInput" placeholder="请输入" maxlength="100"
              v-model="scope.row.expense_amount" clearable @blur="handleEdit(scope)" @change="v => changeData(v, scope)"
              v-if="scope.row.editFlag" />
            <div class="inner" v-else @click="handleCurrentChange(scope, 'expenseAmount')">{{ scope.row.expense_amount
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="备注" header-align="center" min-width="350" align="left">
          <template slot-scope="scope">
            <el-input type="textarea" :autosize="{ minRows: 4 }" ref="description" placeholder="请输入" maxlength="100"
              v-model="scope.row.description" clearable @blur="handleEdit(scope)" @change="v => changeData(v, scope)"
              v-if="scope.row.editFlag" />
            <div class="inner cell" @click="handleCurrentChange(scope, 'description')" v-else>{{ scope.row.description
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contract_no" label="关联品牌或项目" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            <div class="linkwrap normal">
              <el-link @click="showProject(scope)" style="font-size: 12px;">
                {{ scope.row.project_id && scope.row.project_id != '0' ? scope.row.contract_no_name : (scope.row.brand
                  &&
                  scope.row.brand != '' ? scope.row.brand : '关联项目') }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="file" label="附件" header-align="center" align="center" min-width="300">
          <template slot-scope="scope">
            <ul class="anlist" v-if="scope.row.editFlag">
              <li v-for="(_it, _id) in scope.row.atta_str" :key="_id">
                <div class="cbox">
                  <div class="cbox_btn">
                    <el-upload class="upload-demo" :ref="`$upFile${itemList.indexOf(scope.row)}`" action="#" :limit="1"
                      :show-file-list="false" :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png"
                      :file-list="_it.flist"
                      :on-change="(arg) => uploadFile(arg, scope.row.atta_str, `$upFile${itemList.indexOf(scope.row)}`, _it, _id, scope.row)">
                      <span>选择附件</span>
                    </el-upload>
                  </div>
                  <div class="cbox_cancel">
                    <span @click="cancelUpload(scope)">取消</span>
                  </div>
                </div>
              </li>
            </ul>
            <div class="inner" style="height: 23px;" v-else>
              <span v-if="scope.row.atta_str[0].origin_name">{{ scope.row.atta_str[0].origin_name }}</span>
              <span v-else @click="handleCurrentChange(scope, 'file')">上传附件</span>
              <span @click="handleCurrentChange(scope, 'file')" v-if="scope.row.atta_str[0].origin_name"
                class="a-remind"><i class="el-icon-edit"></i></span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" label="操作" header-align="center" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="showDelete(scope)"><i class="el-icon-delete"></i>删除</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="add">
        <el-button @click="addFn"><i class="el-icon-circle-plus" style="margin-right: 10px;"></i>新增明细</el-button>
      </div>
      <div class="expense">
        <div>当前报销金额：{{ form.total_expense_amount }}</div>
        <div>当前业务报销金额：{{ form.total_business_amount }}</div>
        <div>当前日常报销金额：{{ form.total_daily_amount }}</div>
      </div>
    </div>

    <div class="btnarea">
      <div class="left">
        <el-button @click="resetForm('form')">取消</el-button>
        <el-button type="primary" @click="submitForm('form', '1')" v-if="form.is_draft == '1'">保存</el-button>
      </div>
      <div class="right">
        <el-button type="primary" @click="showConfirm" v-if="NodeInclude('188')">申请报销</el-button>
      </div>
    </div>

    <el-dialog title="关联项目" :visible.sync="projectShow" width="500px">
      <el-form ref="projectForm" :model="projectForm" label-width="150px" label-position="left">
        <el-form-item label="关联客户：" prop="client_id">
          <el-col :span="24">
            <el-select v-model="projectForm.client_id" placeholder="选择客户" style="margin-right: 0; width: 100%;"
              filterable @change="clientChange">
              <el-option :label="v.company" :value="v.id" v-for="(v, i) in clientList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="关联品牌：" prop="brand">
          <el-col :span="24">
            <el-select v-model="projectForm.brand" placeholder="选择品牌" style="margin-right: 0; width: 100%;" filterable
              @change="brandChange">
              <el-option :label="v.brand" :value="v.brand" v-for="(v, i) in brandList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="关联项目：" prop="project_id">
          <el-col :span="24">
            <el-select v-model="projectForm.project_id" placeholder="选择项目" style="margin-right: 0; width: 100%;"
              filterable @change="projectChange">
              <el-option :label="v.contract_no + '-' + v.contract_name" :value="v.id" v-for="(v, i) in projectList"
                :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <div style="text-align: center;">注：关联项目后不能修改</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="projectShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmProjectId">确认关联</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除" :visible.sync="deleteShow" width="500px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>是否确认删除</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteShow = false">取 消</el-button>
        <el-button type="primary" @click="handleDelete()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="报销确认" :visible.sync="confirmShow" width="600px">
      <ul class="aul ulist" style="padding:0; min-height: 100px;">
        <li>
          <span>报销日期：</span>
          <span>{{ form.expense_date_str }}</span>
        </li>
        <li>
          <span>报销金额：</span>
          <span>{{ form.total_expense_amount }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ userArr.realname }} {{ userArr.en_name }}</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmShow = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form', '0')">确 定</el-button>
      </span>
    </el-dialog>

  </el-main>
</template>

<script>
import * as api from '@/api'
import { thousands, limitInput } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'expenseDetail',
  data() {
    return {
      returnUrl: true, // 确实是否为手动按钮触发，还是右上角触发
      nodeLimtList: [],
      level: '',
      userId: '',
      serviceList: [],
      clientList: [],
      brandList: [],
      projectList: [],
      userArr: {
        realname: '',
      },
      itemList: [
        { id: '', service_type: '', category_name: '请选择服务类目', expense_amount: '', description: '', brand: '', project_id: '', contract_no_name: '', editFlag: false, atta_str: [{ origin_name: '', file_name: '', httpImg: '', id: '', flist: [] }], }
      ],
      projectShow: false,
      projectForm: {
        index: '',
        id: '',
        client_id: '',
        brand: '',
        project_id: '',
        contract_no_name: ''
      },
      deleteShow: false,
      deleteForm: {
        index: '',
      },
      confirmShow: false,
      form: {
        total_expense_amount: '0.00',
        total_business_amount: '0.00',
        total_daily_amount: '0.00',
      },
      del_detail_list: [],
      p: 1,
      rules: {
        // client_company: [
        //   {
        //     required: true,
        //     message: '请输入客户公司名称',
        //     trigger: 'change',
        //   },
        // ],
      },
    }
  },
  created() {
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
    setTimeout(() => {
      //权限
      this.level = store.state.level
      this.userId = store.state.userId
    }, 200);
  },
  mounted() {
    this.getClientList()
    this.getServiceList()
  },
  beforeRouteLeave(to, from, next) {
    if (this.returnUrl) {
      // 这里可以放置你的逻辑，比如提示用户  
      const answer = window.confirm('离开当前页面会保存');
      if (answer) {
        if (this.form.is_draft == '1') {
          this.addUpdateProject(1, false) //false不让页面两次回退
        }
        else {
          this.addUpdateProject(0, false) //false不让页面两次回退
        }
        next();
      } else {
        next(false); // 取消路由变更  
      }
    }
    next();
  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    _limitInput(v) {
      return limitInput(v)
    },
    //选择文件 type 类别(1销售管理 2采购管理 3项目管理 4行政管理 5报销管理)
    uploadFile(file, fileList, ref, item, index, row) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 5);
      api.uploadFile(formData)
        .then((res) => {
          fileList[index] = item = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpImg: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][0].clearFiles();
          this.$set(row, 'editFlag', false)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancelUpload({ row }) {
      this.$set(row, 'editFlag', false)
    },
    // 在数据源发生变化后，手动刷新数据
    refreshData() {
      // 上传成功后，获取文件的URL，并更新表格数据

    },
    async getClientList() {
      this.$fly.post('ApiAdministrative_brandDropdownList.html', {

      })
        .then((res) => {
          this.clientList = res
        })
    },
    getBrandList(id) {
      this.$fly.post('ApiAdministrative_brandDropdownList.html', {
        client_id: id
      })
        .then((res) => {
          this.brandList = res
        })
    },
    async getServiceList() {
      this.$fly
        .post('ApiAdministrative_serviceTypeDropdownList.html', {
          per_page: 5000,
          id: '10'
        })
        .then((res) => {
          this.serviceList = res
        })
    },
    async getUserDetail(id) {
      this.$fly
        .post('ApiStaffReimbursement_getStaffInfo.html', {
          uid: id,
        })
        .then((res) => {
          this.userArr = res
        })
    },
    getProjectList(client, brand) {
      this.$fly
        .post('ApiAdministrative_projectDropdownList.html', {
          client_id: client,
          brand: brand,
        })
        .then((res) => {
          this.projectList = res.length ? res : []
        })
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const apiUrl = 'ApiStaffReimbursement_getStaffReimbursementDetail.html'
      this.$fly
        .post(apiUrl, {
          reimbursement_id: id,
        })
        .then((res) => {
          let form = res
          this.isDraft = form.is_draft
          form.expense_date_str = this.dateForm(form.expense_date)
          this.getUserDetail(form.user_id)
          const atta_str = () => [{ origin_name: '', file_name: '', httpImg: '', id: '', flist: [] }]
          //防空情况
          if (res.reimbursement_detail.length === 0) {
            this.itemList = [{ id: '', service_type: '', category_name: '请选择服务类目', expense_amount: '', description: '', brand: '', project_id: '', contract_no_name: '', editFlag: false, atta_str: atta_str() }]
          }
          else {
            this.itemList = form.reimbursement_detail.map(({ id, service_type, service_type_name, expense_amount, description, brand, project_id, project, reimbursement_file }) => {
              reimbursement_file.flist = []
              return {
                id,
                service_type,
                category_name: service_type_name,
                expense_amount,
                description,
                brand,
                project_id,
                contract_no_name: project_id == '0' ? '关联项目' : `${project.contract_no}-${project.contract_name}`,
                atta_str: Object.keys(reimbursement_file).length != 0 ? [reimbursement_file,] : atta_str()
              }
            })
            console.log(this.itemList);
          }
          this.form = form
          this.numberFn()
        })
    },
    dateForm(str) {
      const strArr = str.split('-')
      return `${strArr[0]}年${strArr[1]}月`
    },
    //点击添加
    addFn() {
      const item = { id: '', service_type: '', category_name: '请选择服务类目', expense_amount: '', description: '', brand: '', project_id: '', contract_no_name: '', editFlag: false, atta_str: [{ origin_name: '', file_name: '', httpImg: '', id: '' }], }
      this.itemList.push(item)
      this.$forceUpdate()
    },
    showDelete({ row }) {
      const index = this.itemList.indexOf(row)
      this.deleteForm.index = index
      this.deleteShow = true
    },
    //点击删除
    handleDelete() {
      const _index = this.deleteForm.index
      console.log(_index);
      this.del_detail_list.push(this.itemList[_index].id);
      console.log(this.del_detail_list);
      this.itemList.splice(_index, 1)
      this.deleteShow = false
      this.numberFn()
    },
    handleCurrentChange({ row }, ref) {//显示文本框
      this.$set(row, 'editFlag', true) //当前修改
      if (ref != 'file') {
        this.$nextTick(() => {
          this.$refs[ref].focus()//显示文本框并获取焦点
        })
      }
    },
    handleEdit({ row }) {//隐藏文本框
      this.$set(row, 'editFlag', false)
    },
    changeData(value, { row, column }) {//该方法调用修改的接口进行修改
      if (column.label == '服务类目') {
        for (let i = 0; i < this.serviceList.length; i++) {
          const element = this.serviceList[i];
          if (element.id == value) {
            this.$set(row, 'category_name', element.category_name)
          }
        }
      }
      if (column.label == '金额（元）') {
        row.expense_amount = this._limitInput(value)
      }
      this.$set(row, 'editFlag', false)
      this.numberFn()
    },
    showProject({ row }) {
      const index = this.itemList.indexOf(row)
      this.projectForm = {
        index: index,
        id: row.detail_id ? row.detail_id : '',
        client_id: '',
        brand: '',
        project_id: '',
        contract_no_name: ''
      },
        this.projectShow = true
    },
    clientChange(v) {
      this.getBrandList(v)
    },
    brandChange(v) {
      this.projectForm.brand = v
      this.projectForm.project_id = '',
      this.projectForm.contract_no_name = ''
      this.getProjectList(this.projectForm.client_id, v)
    },
    projectChange(v) {
      for (let i = 0; i < this.projectList.length; i++) {
        let element = this.projectList[i];
        if (element.id == v) {
          this.projectForm.contract_no_name = `${element.contract_no}-${element.contract_name}`
        }
      }
    },
    confirmProjectId() {
      if (!this.projectForm.brand) {
        this.$message.error('需要关联到品牌或者项目')
        return false
      }
      const _index = this.projectForm.index
      this.itemList[_index].brand = this.projectForm.brand
      if (this.projectForm.project_id) {
        this.itemList[_index].project_id = this.projectForm.project_id
        this.itemList[_index].contract_no_name = this.projectForm.contract_no_name
      }
      else {
        this.itemList[_index].project_id = ''
        this.itemList[_index].contract_no_name = ''
      }
      //确认完毕关闭弹窗清空临时form
      this.projectShow = false
      this.projectForm = {}
    },
    //计算数字
    numberFn() {
      let expense = 0, daliy = 0, business = 0;
      for (let i = 0; i < this.itemList.length; i++) {
        const _item = this.itemList[i];
        if (_item.service_type == '73' || _item.service_type == '76' || _item.service_type == '77') {
          daliy += Number(_item.expense_amount)
        }
        else if (_item.service_type == '74' || _item.service_type == '75') {
          business += Number(_item.expense_amount)
        }
        expense += Number(_item.expense_amount)
      }
      this.form = {
        ...this.form,
        total_expense_amount: thousands(Number(expense)),
        total_business_amount: thousands(Number(business)),
        total_daily_amount: thousands(Number(daliy)),
      }
    },
    showConfirm() {
      if (this.level != '1') {
        if (!this.judgetMent(this.form)) {
          this.$message.error('只有待提交和审核不通过状态才可编辑!')
          return false
        }
      }
      this.confirmShow = true;
    },
    submitForm(formName, is_draft = '1') {
      // if (!this.form.total_expense_amount || this.form.total_expense_amount != '0.00') {
      //   this.$message.error('请先添加至少一条报销!')
      //   return false
      // }
      this.returnUrl = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateProject(is_draft, true)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateProject(is_draft = '1', canReturn = true) {
      this.form.id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      const tempForm = JSON.parse(JSON.stringify(this.form))
      const { id, user_id, description, expense_date, total_expense_amount, option } = tempForm
      const postData = { id, user_id, description, expense_date, option }
      // 替换掉id为detail_id
      const $itemList = this.itemList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['detail_id'] = item[key] || 0
            console.log(item['detail_id']);
            delete item[key]
          }
        })
        // 替换掉id为file_id
        item.atta_str = item.atta_str.map((it) => {
          delete it.flist
          delete it.httpImg
          Object.keys(it).forEach(_key => {
            if (_key == 'id') {
              it['file_id'] = it[_key] || 0
              delete it[_key]
            }
          })
          return it
        })
        return item
      })
      this.$fly
        .post('ApiStaffReimbursement_createOrUpdateStaffReimbursement.html', {
          ...postData,
          expense_amount: total_expense_amount,
          detail_str: JSON.stringify($itemList),
          detail_del: this.del_detail_list.toString(),
          is_draft: is_draft,
          is_creat: (this.form.option == '2' && this.isDraft != is_draft) ? '1' : '',
          //isDraft为临时存储接收到的is_draft
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          if (canReturn) {
            this.$router.go(-1)
          }
        })
    },
    resetForm(formName) {
      this.returnUrl = false
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    judgetMent(obj) {
      if (obj.status == '0' || (obj.status == '1' && obj.leader_check_status == '3') || (obj.status == '1' && obj.leader_check_status == '2' && obj.finance_check_status == '3')) {
        return true //可编辑
      }
      else if (obj.status == '1' || (obj.status == '1' && obj.leader_check_status == '2') || (obj.status == '1' && obj.leader_check_status == '2' && obj.finance_check_status == '2')) {
        return false //不可编辑
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }



          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }
        }
      }
    }

  }

  .inner {
    display: block;
    min-height: 23px;

    span {
      margin-right: 10px;
      font-size: 12px;
      display: inline-block;
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;

      &.a-remind {
        font-size: 16px;
        cursor: pointer;
      }
    }

  }

  .btnarea {
    @extend %box;
    @extend %start;
    padding: 30px 40px;
    position: relative;

    .left {
      width: 500px;
    }

    .right {
      width: 300px;
    }
  }

  .table {
    .add {
      padding: 20px 48px 0;
    }

    .expense {
      @extend %start;
      padding: 30px 0;

      >div {
        margin-right: 30px;
      }
    }

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .cbox {
          @extend %start;
          justify-content: space-around;
          align-items: center;

          div {
            span:hover {
              border-bottom: 1px solid #000;
              cursor: pointer;
            }
          }

          .cbox_btn {
            i {
              font-size: 22px;
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}

.aul.ulist {
  padding: 20px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;
      width: 50%;
    }
  }

  .ulform {
    padding: 0 60px;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}
</style>
